
export const PASSWORD_GRANT_STORAGE_KEY = 'cheddule.passwordGrant';

export function readStashedGrant(): string | null {
  try {
    return window.sessionStorage.getItem(PASSWORD_GRANT_STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Is there a pending single-use password grant? The gate (App.tsx) reads this to decide whether to
 * mount the set-password surface ABOVE the session switch: the grant, not the cookie session, is
 * the real authorization for the password set, so its presence (not the resolved `/auth/me`) is
 * what gates the screen. A thin readability wrapper over {@link readStashedGrant}.
 */
export function hasPendingPasswordGrant(): boolean {
  return readStashedGrant() !== null;
}

/** Stash a single-use password grant for the grant-gated SetPassword surface. Written by the
 *  auth callback and (for the deadlock fix) by App.tsx from the fresh `/auth/me` setup-incomplete grant. */
export function stashGrant(grant: string): void {
  try {
    window.sessionStorage.setItem(PASSWORD_GRANT_STORAGE_KEY, grant);
  } catch {
    // sessionStorage unavailable (private mode / disabled): the gate falls back to the session route.
  }
}

/** Clear the stashed grant once it's been consumed (so a refresh can't replay a spent grant), and
 *  on any session-identity change (logout, fresh login): a leftover grant belongs to the PREVIOUS
 *  account and would silently set that account's password from the grant-gated screen. */
export function clearStashedGrant(): void {
  try {
    window.sessionStorage.removeItem(PASSWORD_GRANT_STORAGE_KEY);
  } catch {
  }
}
